import { Flex, Text, TextField } from '@radix-ui/themes'
import { colorOrFallback } from '../utils'
import '../styles.scss'

const SWATCH_FALLBACK = '#000000'

type ColorInputProps = {
  id: string
  label: string
  value: string
  error?: string
  onChange: (value: string) => void
  onBlur: () => void
}

export const ColorInput = ({ id, label, value, error, onChange, onBlur }: ColorInputProps) => {
  // A colour input has no empty state, so a blank or half-typed hex shows the fallback swatch.
  const swatch = colorOrFallback(value, SWATCH_FALLBACK)

  return (
    <Flex direction="column" gap="2">
      <label htmlFor={id}>
        <Text size="2" weight="medium">
          {label}
        </Text>
      </label>
      <Flex gap="2" align="center">
        <input
          type="color"
          className="color-swatch"
          aria-label={`${label} picker`}
          value={swatch}
          onChange={(e) => onChange(e.target.value)}
        />
        <TextField.Root
          id={id}
          className="flex-1"
          placeholder="#RRGGBB"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onBlur={onBlur}
        />
      </Flex>
      {error && (
        <Text size="1" color="red">
          {error}
        </Text>
      )}
    </Flex>
  )
}
